import api from "./config"; 

// 📌 MÉDICOS (Gestión de doctores)

  export const getMedicoAuth = async () => {
    try {
      const response = await api.get("/medicos/me/");  // ✅ Obtener solo el médico autenticado
      return response.data;
    } catch (error) {
      console.error("Error obteniendo datos del médico autenticado:", error);
      return null;
    }
  };
  

export const addMedico = async (medico) => {
  try {
    medico.activo = true; // Por defecto, un nuevo médico está activo
    const response = await api.post("/registro/", medico);
    return response.data;
  } catch (error) {
    console.error("Error agregando médico:", error);
    return null;
  }
};

export const updateDireccion = async (direccionData) => {
  try {
    const response = await api.patch("/direccion/", direccionData); // usa patch o put
    return response.data;
  } catch (error) {
    console.error("Error actualizando dirección:", error);
    return null;
  }
};
export const updatePerfilMedico = async (perfilData) => {
  try {
    const response = await api.patch("/perfil/", perfilData);
    return response.data;
  } catch (error) {
    console.error("Error actualizando perfil médico:", error);
    return null;
  }
};


export const updateMedico = async ( medicoActualizado) => {
  try {
    const response = await api.patch(`/medicos/me/`, medicoActualizado);
    return response.data;
  } catch (error) {
    console.error("Error actualizando médico:", error);
    return null;
  }
};
export const getPerfilMedico = async () => {
  try {
    const response = await api.get("/perfil/");
    return response.data;
  } catch (error) {
    console.error("Error obteniendo perfil médico:", error);
    return null;
  }
};

export const getEstadoBloqueoNom = async () => {
  try {
    const response = await api.get("/perfil/estado-bloqueo-nom/");
    return response.data;
  } catch (error) {
    console.error("Error obteniendo estado de bloqueo NOM:", error);
    return null;
  }
};

export const deleteMedico = async (id) => {
  try {
    // Obtener las citas del médico antes de "eliminarlo"
    const citas = await api.get(`/citas?medicoId=${id}`);

    // Marcar sus citas futuras como "cancelada"
    for (let cita of citas.data) {
      await api.put(`/citas/${cita.id}`, { ...cita, estado: "cancelada" });
    }

    // Marcar el médico como inactivo en lugar de eliminarlo
    await api.put(`/medicos/${id}`, { activo: false });
    return true;
  } catch (error) {
    console.error("Error eliminando médico:", error);
    return false;
  }
};

// 🔹 Validar CLUES contra catálogo oficial
export const validarCluesCatalogo = async (clues) => {
  try {
    const response = await api.get(`/catalogos/establecimientos/?search=${clues}&limit=1`);
    return response.data.length > 0 ? response.data[0] : null;// debe regresar { clues, nombre_unidad }
  } catch (error) {
    return null;
  }
};

// 🔹 Validar si el CLUES está en el directorio de servicios amigables (NOM-024, código 22)
export const validarCluesServicioAmigable = async (clues) => {
  try {
    const response = await api.get(`/catalogos/servicios_amigables/?search=${clues}`);
    return response.data.length > 0;
  } catch (error) {
    return false;
  }
};
// 🔹 Validar pais contra catálogo oficial
export const getCatalogoPais = async () => {
  try {
    const response = await api.get(`/catalogos/pais/?limit=500`);
    return response.data;
  } catch (error) {
    return [];
  }
};

// 🔹 Catálogo de entidades federativas
export const getCatalogoEntidades = async () => {
  try {
    const response = await api.get(`/catalogos/entidades/`);
    return response.data;
  } catch (error) {
    return [];
  }
};

// 🔹 Catálogo de municipios por entidad
export const getCatalogoMunicipios = async (efeKey) => {
  try {
    const response = await api.get(`/catalogos/municipios/?efe_key=${efeKey}`);
    return response.data;
  } catch (error) {
    return [];
  }
};

// 🔹 Catálogo de localidades por entidad y municipio
export const getCatalogoLocalidades = async (efeKey, munKey) => {
  try {
    const response = await api.get(`/catalogos/localidades/?efe_key=${efeKey}&mun_key=${munKey}`);
    return response.data;
  } catch (error) {
    return [];
  }
};

// 🔹 Catálogo de afiliación
export const getCatalogoAfiliacion = async () => {
  try {
    const response = await api.get(`/catalogos/afiliacion/`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo catálogo de afiliación:", error);
    return [];
  }
};

// 🔹 Catálogo oficial de tipo de personal
export const getCatalogoTipoPersonal = async () => {
  try {
    const response = await api.get(`/catalogos/tipo_personal/?limit=500`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo catálogo de tipo de personal:", error);
    return [];
  }
};

// 🔹 Onboarding: video de bienvenida
export const consultarVideoOnboarding = async (url) => {
  try {
    const response = await api.get("/onboarding/video/", { params: { url } });
    return response.data.mostrar === true;
  } catch (error) {
    return false;
  }
};

export const registrarEventoVideo = async (url, evento, origen = "modal") => {
  try {
    const response = await api.post("/onboarding/video/evento/", { url, evento, origen });
    return response.data;
  } catch (error) {
    return null;
  }
};